const side_menus = () => {
    $('.main-nav').children().clone().appendTo('.side-nav');

    $('.burger-menu').click(function () {
        $('.burger-line').toggleClass('black-burger-menu');
        $('.line1').toggleClass('crossed1');
        $('.line2').toggleClass('crossed2');
        $('.line3').toggleClass('crossed3');
        $('.side-menu').toggleClass('visible');
    });

    $(".search").click(function () {
        $(".search-section").fadeIn();
        $(".menu, .search").addClass("hidden");
    });

    $(".close-search").click(function () {
        $(".search-section").fadeOut();
        $(".menu, .search").removeClass("hidden");
    });
}

export default side_menus;